
export const RECORD_PER_PAGE = {
    ten: 10,
    fourThousand: 4000,
    fiveThousand: 5000,
    sixThousand: 6000,
    tenThousand: 10000
  };

  export const AG_GRID_INPUTS = {
    pageSize: 5000,
    updateHistoryPageSizes: 10,
    pageNumber: 1,
    detailedEditingDefaultPageNumber:1,
    decimalNumber: 2,
    productsLevelIndent: 5,
    fullDecimalNumber: 10,
    productsFirstLevelId: 1,
    textColumnFilter: 'agTextColumnFilter',
    numericColumnFilter: 'agNumberColumnFilter',
    filterParams: {
      buttons: ['reset', 'apply'],
      closeOnApply: true,
      trimInput: true
    },
    updateHistoryFilterParams: {
      filterOptions: ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith'],
      buttons: ['reset', 'apply'],
      closeOnApply: true,
      trimInput: true
    },
    keyUpName: 'ArrowUp',
    keyDownName: 'ArrowDown',
    contextMenuItems: ['copy', 'copyWithHeaders'],
    agGridLicenseEncryptionSecretKey: '10638873128599169687651928976018',
    maximumFractionDigits: 12,
    yearDefaultLength: 4,
    tooltipShowDelayMilliSeconds: 1000,
    headerHeight: 34,
    rowHeight: 30,
    paginatorItemsPerPageLabelText: 'Page Size',
    pageSizeOptions: [
      RECORD_PER_PAGE.ten,
      RECORD_PER_PAGE.fourThousand,
      RECORD_PER_PAGE.fiveThousand,
      RECORD_PER_PAGE.sixThousand,
      RECORD_PER_PAGE.tenThousand
    ],
    numberOne: 1,
    numberTwo: 2,
    previousPageNumber: 0,
    paginationSeries:1,
    previousPageSize:0
  };